module.exports = __webpack_public_path__ + "static/media/ST1.a89d479b.mp3";